import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { StyledTypography } from "components/StyledComponents/styledComponents.js";
import {
  TableContainer,
  Paper,
  Grid,
  TextField,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  ViewButton,
} from "components/StyledComponents/styledComponents.js";
import { CustomPaper } from "components/Styles/globalStyles";
import Cookie from "js-cookie";
import { useNavigate } from "react-router-dom";
import URLs from "constants/urls";
import VisibilityIcon from "@mui/icons-material/Visibility";

// Add this style object at the top of your component
// const tableStyles = {
//   table: {
//     borderCollapse: 'collapse',
//     width: '100%',
//     border: '1px solid rgba(224, 224, 224, 1)',
//     tableLayout: 'fixed',
//   },
//   tableCell: {
//     border: '1px solid rgba(224, 224, 224, 1)',
//     padding: '12px',
//     textAlign: 'center',
//     fontSize: '14px',
//     whiteSpace: 'nowrap',
//     overflow: 'hidden',
//     textOverflow: 'ellipsis',
//   },
//   tableHeader: {
//     border: '1px solid rgba(224, 224, 224, 1)',
//     padding: '12px',
//     textAlign: 'center',
//     backgroundColor: '#f5f5f5',
//     fontWeight: 'bold',
//     fontSize: '14px',
//   },
//   viewButton: {
//     minWidth: '40px',
//     padding: '4px',
//   },
//   tableContainer: {
//     marginTop: 3,
//     overflowX: 'auto',
//   }
// };

const fieldStyles = {
  container: {
    display: "flex",

    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #ddd",
    margin: "4px 0",
    alignItems: "center",
  },
  label: {
    width: "150px",
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRight: "1px solid #ddd",
    fontWeight: "bold",
    fontSize: "14px",
  },
  value: {
    padding: "12px",
    flex: 1,
    fontSize: "14px",
  },
  viewButton: {
    minWidth: "40px",
    padding: "4px",
    marginRight: "12px",
  },
};

export default function PaySlips() {
  const [companyCode, setCompanyCode] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeData, setEmployeeData] = useState([]);
  const [dsaData, setDsaData] = useState([]);
  const [payslipsData, setPayslipsData] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");

  const jwt_token = Cookie.get("jwt_token");
  const navigate = useNavigate();
  const MInput = inputStyle();

  // Fetch company data
  const fetchDsaMasterData = async () => {
    const url = URLs.dsaMasterGetUrl;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    try {
      const response = await fetch(url, options);

      const data = await response.json();
      setDsaData([...data.data]);
    } catch (error) {
      setAlert("Failed to fetch company data", "error");
    }
  };

  // Fetch employee data based on company
  const fetchEmployeeData = async (companyId) => {
    const url = `${URLs.employeeMasterGetUrl}?companyId=${companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    try {
      const response = await fetch(url, options);

      const data = await response.json();
      setEmployeeData(data);
    } catch (error) {
      setAlert("Failed to fetch employee data", "error");
    }
  };

  // Fetch payslips data (implement your actual API call)
  const fetchPayslipsData = async (employeeId) => {
    // Sample data - replace with actual API call
    setPayslipsData([
      {
        id: 1,
        payPeriod: "Jan 2024",
        workingDays: 22,
        attendance: 21,
        leaves: 1,
        lop: 0,
        addition: 5000,
        deduction: 1000,
        netPay: 45000,
      },
      // Add more sample data as needed
    ]);
  };

  useEffect(() => {
    fetchDsaMasterData();
  }, []);

  useEffect(() => {
    if (companyCode) {
      fetchEmployeeData(companyCode);
    }
  }, [companyCode]);

  useEffect(() => {
    if (selectedEmployee) {
      fetchPayslipsData(selectedEmployee.employeeId);
    }
  }, [selectedEmployee]);

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewPayslip = (payslipId) => {
    // Implement view functionality
    console.log("Viewing payslip:", payslipId);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TableContainer component={Paper} sx={{ mt: 5 }}>
        <Box sx={{ p: 3 }}>
          <StyledTypography>View Payslips</StyledTypography>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={dsaData}
                  getOptionLabel={(option) => option.dsaName}
                  value={selectedCompany}
                  onChange={(event, value) => {
                    setCompanyCode(value ? value.dsaId : "");
                    setSelectedCompany(value);
                  }}
                  PaperComponent={CustomPaper}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Company"
                      required
                      sx={MInput.b}
                      InputLabelProps={{
                        sx: { color: MInput.a },
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={employeeData}
                  getOptionLabel={(option) =>
                    `${option.employeeFirstName} ${option.employeeLastName}`
                  }
                  value={selectedEmployee}
                  onChange={(event, value) => setSelectedEmployee(value)}
                  PaperComponent={CustomPaper}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Employee"
                      required
                      sx={MInput.b}
                      InputLabelProps={{
                        sx: { color: MInput.a },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 3 }}>
              {payslipsData.length > 0 ? (
                payslipsData.map((item) => (
                  <Box
                    key={item.id}
                    sx={{ mb: 4, border: "1px solid #ddd", borderRadius: "4px", p: 2 }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                      <ViewButton
                        onClick={() => handleViewPayslip(item.id)}
                        sx={fieldStyles.viewButton}
                      >
                        <VisibilityIcon fontSize="small" />
                      </ViewButton>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>Pay Period</Box>
                      <Box sx={fieldStyles.value}>{item.payPeriod}</Box>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>Working Days</Box>
                      <Box sx={fieldStyles.value}>{item.workingDays}</Box>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>Attendance</Box>
                      <Box sx={fieldStyles.value}>{item.attendance}</Box>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>Leaves</Box>
                      <Box sx={fieldStyles.value}>{item.leaves}</Box>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>LOP</Box>
                      <Box sx={fieldStyles.value}>{item.lop}</Box>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>Addition</Box>
                      <Box sx={fieldStyles.value}>₹{item.addition.toLocaleString()}</Box>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>Deduction</Box>
                      <Box sx={fieldStyles.value}>₹{item.deduction.toLocaleString()}</Box>
                    </Box>

                    <Box sx={fieldStyles.container}>
                      <Box sx={fieldStyles.label}>Net Pay</Box>
                      <Box sx={fieldStyles.value}>₹{item.netPay.toLocaleString()}</Box>
                    </Box>
                  </Box>
                ))
              ) : (
                <Box
                  sx={{
                    textAlign: "center",
                    p: 3,
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                  }}
                >
                  No payslips available
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </TableContainer>

      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
    </DashboardLayout>
  );
}
